<div id="modalrooms" style="position: relative;">
    <div class="modal-content" style="padding-bottom: 50px;padding: 3em 4.5em;">

      <div class="d-flex justify-content-between mx-auto" style="width: 98%">
          <p class="title mb-0 mt-2" style="font-family: 'Rubik', sans-ferif;font-size: 30px;font-weight: 500;line-height: 1 !important; color: #3f3f3f !important;">
            {{ product.title }}
          </p>
        <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
          <span aria-hidden="true" style="font-size: 50px; font-weight: 100;">&times;</span>
        </button>
      </div>

    <ng-container *ngIf="categoryId === 1">
      <div class="d-flex align-items-start" style="margin-left: .8em;margin-bottom:.85em">
        <ng-container *ngFor="let star of starArray">
            <img
              *ngIf="star <= rate"
              class="mr-1"
              width="13"
              height="13"
              src="../../../../../../assets/icons/itinerary/estrella-01.svg"
              alt="estrella"
            />
            <img
              class="mr-1"
              *ngIf="star > rate"
              width="13"
              height="13"
              style="filter: grayscale(1); opacity: 0.5"
              src="../../../../../../../assets/icons/itinerary/estrella-01.svg"
              alt="estrella"
            />
          </ng-container>
      </div>
      <div class="d-flex align-items-start justify-content-start" style="gap: .5em;margin-bottom: 6px">
        <div class="d-flex justify-content-start" >
          <div class="d-flex mr-1">
            <i class="i-placeholder" style="margin-left: 4px"></i>
          </div>
          <div *ngIf="hotel?.additionalInfo?.location" class="d-flex justify-content-between align-items-center " style="width: 100%;">
            <div class="d-flex flex-column justify-content-center" >
              <p *ngIf="getAddress(hotel?.additionalInfo?.location, true)" class=" mb-0 line-height" style="font-family: 'Rubik', sans-serif;font-size: 14px;font-weight: 600;color: #3f3f3f !important">{{stingUpperCase(getAddress(hotel?.additionalInfo?.location, true))}}</p>
              <p *ngIf="getAddress(hotel?.additionalInfo?.location, false)" class=" mb-0 line-height" style="font-family: 'Rubik', sans-serif;font-size: 14px;font-weight: 600;color: #3f3f3f !important">{{stingUpperCase(getAddress(hotel?.additionalInfo?.location, false))}}</p>
              <p class=" mb-0 line-height" style="font-family: 'Rubik', sans-serif;font-size: 14px;font-weight: 600;color: #3f3f3f !important">{{stingUpperCase(payload?.city)}}</p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <usb-tab-buttons
                    [categoryId]="categoryId"
                    [activeTab]="tab"
                    [quote]="quote"
                    [buttonColorActive]="buttonColorActive"
                    [buttonTextActive]="buttonTextActive"
                    [action]="action"
                    [productSelect]="productSelect"
                    (tabChange)="tab = $event"
                    (mapClick)="mapMarker()">
    </usb-tab-buttons>

    <ng-container [ngSwitch]="categoryId">
  
      <!-- Hoteles (categoryId: 1) -->
      <usb-modal-hotel *ngSwitchCase="1"
        [currencyAgency]="currencyAgency" 
        [currencies]="currencies" 
        [payload]="payload" 
        [clientSetting]="clientSetting" 
        [arrivalDate]="arrivalDate" 
        [departureDate]="departureDate" 
        [hotel]="product" 
        [productQty]="productQty" 
        [form]="form" 
        [view_info]="view_info"
        [payloadUpdate]="payloadUpdate" 
        [paymentAgencyActive]="paymentAgencyActive" 
        [itineraryItem]="itineraryItem" 
        [arrayResults]="arrayResults"  
        [tabActive]="tabActive"  
        (refModal)="hideModal($event)" 
        [quote]="quote" 
        [action]="action">
      </usb-modal-hotel>

            <!-- Rent a Car (categoryId: 2) -->
      <usb-modal-rentacar *ngSwitchCase="2"
        [rentaCar]="product" 
        [currencyAgency]="currencyAgency" 
        [currencies]="currencies" 
        [productQty]="productQty" 
        [form]="form" 
        [payloadUpdate]="payloadUpdate"
        [itineraryItem]="itineraryItem" 
        [arrayResults]="arrayResults" 
        (refModal)="hideModal($event)" 
        [tabActive]="tabActive" 
        [clientSetting]="clientSetting" 
        [quote]="quote" 
        [action]="action">
      </usb-modal-rentacar>

      <!-- PThemes / Experiences (categoryId: 6) -->
      <!-- <usb-modal-pthemes *ngSwitchCase="6"
        [ptheme]="product" 
        [form]="form" 
        [payloadUpdate]="payloadUpdate"
        [itineraryItem]="itineraryItem" 
        [arrayResults]="arrayResults" 
        (refModal)="hideModal($event)">
      </usb-modal-pthemes> -->

            <!-- Tours (categoryId: 6 - si es mismo que PThemes, ajustar) -->
      <usb-modal-tours *ngSwitchCase="[6, 9]"
        [tour]="product" 
        [currencyAgency]="currencyAgency" 
        [currencies]="currencies" 
        [payloadUpdate]="payloadUpdate" 
        [itineraryItem]="itineraryItem"
        [arrayResults]="arrayResults" 
        [form]="form" 
        (refModal)="hideModal($event)" 
        [paymentAgencyActive]="paymentAgencyActive" 
        [tabActive]="tabActive" 
        [clientSetting]="clientSetting" 
        [quote]="quote" 
        [action]="action">
      </usb-modal-tours>

      <!-- Packages (categoryId: ?) -->
      <!-- <usb-modal-packages *ngSwitchCase="5"
        [packages]="product" 
        [productQty]="productQty" 
        [form]="form" 
        [payloadUpdate]="payloadUpdate"
        [itineraryItem]="itineraryItem" 
        [arrayResults]="arrayResults" 
        (refModal)="hideModal($event)">
      </usb-modal-packages> -->

      <!-- Disney (categoryId: ?) -->
      <usb-modal-disney *ngSwitchCase="7"
        [hotel]="product" 
        [productQty]="productQty" 
        [form]="form" 
        [payloadUpdate]="payloadUpdate"
        [arrayResults]="arrayResults" 
        [_item]="_item"  
        (refModal)="hideModal($event)">
      </usb-modal-disney>

      <!-- Transportes (categoryId: 8) -->
      <usb-modal-transports *ngSwitchCase="8"
        [tabActive]="tabActive" 
        [service]="product" 
        [currencyAgency]="currencyAgency" 
        [currencies]="currencies" 
        [clientSetting]="clientSetting" 
        [productQty]="productQty" 
        [form]="form" 
        [view_info]="view_info"
        [payloadUpdate]="payloadUpdate" 
        [vehicles]="vehicles" 
        [payload]="payload" 
        [paymentAgencyActive]="paymentAgencyActive" 
        [formTransport]="formTransport" 
        [fliyingInfo]="fliyingInfo"  
        [arrayResults]="arrayResults" 
        [_item]="_item" 
        (refModal)="hideModal($event)" 
        [quote]="quote" 
        [action]="action">
      </usb-modal-transports>

      <!-- Insurance (categoryId: 10) -->
      <usb-modal-insurance *ngSwitchCase="10"
        [insurance]="product" 
        [form]="form" 
        [payloadUpdate]="payloadUpdate" 
        [payload]="payload" 
        [clientSetting]="clientSetting"
        [itineraryItem]="itineraryItem" 
        [arrayResults]="arrayResults"  
        (refModal)="hideModal($event)">
      </usb-modal-insurance>

    </ng-container>

    <div *ngIf="tab === 'product' && quote" class="d-flex pt-4 justify-content-end mr-5" style=" gap: 1em;">
        <div class="d-flex flex-column align-items-end justify-content-center">
            <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 20px;font-weight: 500;line-height: 1; color: #666666">Total Tarifa Neta</p>
            <div class="d-flex">
              <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 22px;font-weight: 700;line-height: 1; color: black">
                <!-- {{currencySelected}} {{totalQty | number:'1.2-2'}} -->
                {{ totalQty
                        | currencyConverterPure:
                          currencySelected:
                          currencyAgency.code:
                          currencies
                        | number: '1.2-2'}}
              </p>
                  <usb-tooltip-convert-amount
                                                [clientsSettingAppBooking]="clientSetting"
                                                [currencyProduct]="currencySelected"
                                                [valueProduct]="totalQty"
                                                >
                  </usb-tooltip-convert-amount>

            </div>
        </div>
        <button
                    type="button"
                    class="btn btn-continue"
                    [ngStyle]="{'background-color':  buttonColorActive, 'color': buttonTextActive}"
                    (click)="continue()"
                    [disabled]="disableButton">Continuar</button>
      </div>

    </div>
</div>